<template>
    <div>
        <a v-if="row.transaction_log_url" :href="row.transaction_log_url" target="_blank"
           class="btn btn-sm btn-clean btn-icon btn-icon-sm">
            <i class="fa fa-history"></i>
        </a>
        <router-link v-if="$can('read-settlement-details','wallet')" :to="`/wallets/admin/pay-settlement/pf/${row.id}`"
           class="btn btn-sm btn-clean btn-icon btn-icon-sm">
            <i class="fas fa-eye"></i>
        </router-link>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default Vue.extend({
        props: {
            row: {
                required: true,
            },
            index: {
                required: true,
            },
            datatable: {
                required: true,
            },
        },
        computed: {
            slug() {
                return this.$route.params.slug || this.$route.query.slug;
            }
        }
    })
</script>
